import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicFilePaymentBig({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M49.5 4v48a3.5 3.5 0 01-3.5 3.5H10A3.5 3.5 0 016.5 52V14.2L20.2.5H46A3.5 3.5 0 0149.5 4z"
        fill="#fff"
        stroke="#E3E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 34.28c0 1.01.82 1.83 1.83 1.83h18.34c1 0 1.83-.82 1.83-1.83v-7.42H17v7.42zm7.33-2.6c0-.25.21-.46.46-.46H30c.25 0 .45.2.45.46v1.53c0 .25-.2.46-.45.46h-5.2a.46.46 0 01-.46-.46v-1.53zm-4.89 0c0-.25.21-.46.46-.46h2.75c.25 0 .46.2.46.46v1.53c0 .25-.2.46-.46.46H19.9a.46.46 0 01-.46-.46v-1.53zM39 20.83v3.01H17v-3c0-1.02.82-1.84 1.83-1.84h18.34c1 0 1.83.82 1.83 1.83z"
        fill="#999"
      />
      <path d="M20 0v10a4 4 0 01-4 4H6L20 0z" fill="#E3E8E8" />
      <rect x={28} y={39} width={27} height={13} rx={2} fill="#3EA769" />
      <path
        d="M34.2 45.63l-2.07-3.06h1.63l1.26 2.06 1.3-2.06h1.56l-2.06 3.07L38.06 49h-1.69l-1.4-2.22L33.54 49h-1.59l2.25-3.37zm4.87-3.06h1.42v5.24h3.13V49h-4.55v-6.43zm6.75 4.3a1.09 1.09 0 00.42.92c.14.09.29.15.46.2a2.3 2.3 0 001.35-.09.9.9 0 00.32-.24c.08-.1.12-.24.12-.4a.56.56 0 00-.17-.43c-.1-.1-.25-.2-.43-.27a4.36 4.36 0 00-.61-.19 16.9 16.9 0 01-1.4-.4c-.22-.08-.43-.2-.6-.34-.19-.13-.33-.3-.45-.5-.1-.22-.16-.47-.16-.77a1.69 1.69 0 01.76-1.46c.23-.16.5-.28.78-.36a3.88 3.88 0 011.83 0c.3.07.58.19.82.36a1.91 1.91 0 01.78 1.6h-1.36a1.1 1.1 0 00-.13-.49.76.76 0 00-.27-.3 1.16 1.16 0 00-.4-.15 2.34 2.34 0 00-.81 0 .8.8 0 00-.54.35.6.6 0 00-.1.34c0 .12.03.23.08.3.05.08.14.15.28.22s.34.13.58.2a137.61 137.61 0 001.48.38 2.07 2.07 0 011.18.86c.15.23.23.52.23.88a1.8 1.8 0 01-.68 1.48c-.22.18-.5.32-.84.42-.33.1-.71.15-1.15.15-.35 0-.7-.04-1.04-.13a2.58 2.58 0 01-.88-.4 2.04 2.04 0 01-.82-1.74h1.37z"
        fill="#fff"
      />
    </svg>
  );
}

SvgPicFilePaymentBig.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicFilePaymentBig.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicFilePaymentBig svgRef={ref} {...props} />
));
export default ForwardRef;
